import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import DateFormat from '../DateFormat';

const StyledBoxDay = styled.time`
  align-items: center;
  background-color: ${props => props.theme.colors.grayDarkest};
  color: ${props => props.theme.colors.grayLightest};
  display: inline-flex;
  padding: ${rem('6px')} ${rem('10px')} ${rem('6px')} ${rem('10px')};

  ${mediaqueries.greaterThan('mobile')`
    background-color: ${props => props.theme.colors.dark};
    flex-flow: column;
    padding: ${rem('6px')} 0;
    width: ${rem('50px')};
  `};
`;

const StyledWeek = styled(DateFormat)`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.medium};
  letter-spacing: ${rem('-0.9px')};
  line-height: 1;
  margin-right: ${rem('5px')};
  text-transform: uppercase;

  ${mediaqueries.greaterThan('mobile')`
    font-size: ${props => props.theme.fontSize.medium};
    margin-right: 0;
  `};
`;

const StyledDay = StyledWeek.extend`
  font-size: ${props => props.theme.fontSize.large};
  letter-spacing: ${rem('-0.6px')};
  margin-right: 0;

  ${mediaqueries.greaterThan('mobile')`
    font-size: ${rem('23px')};
  `};
`;

export { StyledBoxDay, StyledDay, StyledWeek };
